<div class="st-discover-item-attach-to-dialog-label">{{ 'Select a topic to attach to' }}</div>
<mat-button-toggle-group class="st-discover-item-attach-to-dialog-buttons-group">
    <mat-button-toggle
        class="st-discover-item-attach-to-dialog-buttons-group__search"
        [class.st-cast-objects-checked-search]="!savedViewDropdownVisible"
        [checked]="!savedViewDropdownVisible"
        (click)="toggleTabVisibility(false)">
        @if (!savedViewDropdownVisible) {
            <mat-icon class="material-symbols-outlined"> check </mat-icon>
        }
        {{ languageSettings.PSTWebCastSearchTabLabel }}
    </mat-button-toggle>
    <mat-button-toggle
        class="st-discover-item-attach-to-dialog-buttons-group__views"
        [checked]="savedViewDropdownVisible"
        [class.st-cast-objects-checked-saved-views]="savedViewDropdownVisible"
        (click)="toggleTabVisibility(true)">
        @if (savedViewDropdownVisible) {
            <mat-icon class="material-symbols-outlined"> check </mat-icon>
        }
        {{ languageSettings.PSTWebSavedViewsTabLabel }}
    </mat-button-toggle>
</mat-button-toggle-group>

@if (savedViewDropdownVisible) {
    <mat-form-field
        class="st-discover-item-attach-to-dialog--views-dropdown"
        subscriptSizing="dynamic">
        <mat-label>{{ languageSettings.PSTWebCastObjectsDropDownLabel }}</mat-label>

        <mat-select
            [value]="currentViewState()?.guid"
            [placeholder]="languageSettings.PSTWebSavedViewsLabel"
            (selectionChange)="onViewStateGuidChanged($event)">
            @for (item of selectSavedViewStates()?.views; track item.guid) {
                <mat-option [value]="item.guid">
                    {{ item.title }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
} @else {
    <div class="st-discover-item-attach-to-dialog--search-bar">
        <st-text-field
            #searhVal
            [placeholder]="languageSettings.PSTWebSearchPlaceholder"
            (keyup.enter)="onSearchHandler(searhVal.internalValue())"
            (changed)="onSearchHandler(searhVal.internalValue())" />
    </div>
}

<mat-divider class="st-discover-item-attach-to-dialog-divider" />
@if (selectTopics().length === 0) {
    <div class="st-discover-item-attach-to-dialog-text">
        {{ 'There is no content to attach' }}
    </div>
} @else {
    @if (selectIsAttachToTopicListLoading$ | ngrxPush) {
        <st-loader
            class="st-discover-list-loader"
            [productLabel]="languageSettings.PSTWebLoadingLabel"
            [diameter]="200"
            [strokeWidth]="10" />
    } @else {
        <cdk-virtual-scroll-viewport
            maxBufferPx="0"
            minBufferPx="0"
            class="st-discover-item-attach-to-dialog-viewport"
            itemSize="36">
            <div
                *cdkVirtualFor="let record of selectTopics(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
                class="st-discover-item-attach-to-dialog-viewport-topic-item">
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false">
                    <mat-list-option
                        [value]="record?.id"
                        (click)="onAttachItem(record)">
                        <div
                            *ngFor="let item of record?.PSTTopicType"
                            class="st-discover-item-attach-to-dialog-viewport-topic-item-type"
                            st-topic-card-type-color
                            [matTooltip]="item"
                            [itemType]="item"
                            [data]="record"></div>
                        <div class="st-discover-item-attach-to-dialog-viewport-topic-item-title">{{ record.Title }}</div>
                    </mat-list-option>
                </mat-selection-list>
            </div>
        </cdk-virtual-scroll-viewport>
    }
}
<mat-divider class="st-discover-item-attach-to-dialog-divider" />

<mat-button-toggle-group class="st-discover-item-attach-to-dialog-button-group">
    <button
        mat-button
        class="st-discover-item-attach-to-dialog-button-confirm"
        (click)="cancelNew()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
</mat-button-toggle-group>
